import { render, staticRenderFns } from "./SidebarIntent.vue?vue&type=template&id=60cf9040&scoped=true&"
import script from "./SidebarIntent.vue?vue&type=script&lang=js&"
export * from "./SidebarIntent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarIntent.vue?vue&type=style&index=0&id=60cf9040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf9040",
  null
  
)

export default component.exports